import { Button, Form, Select, Spin, Table, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { trimString } from "../../../Utils";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import {
  getBawanaInfraReport,
  submitBawanaInfra,
} from "../../../ApiServices/Apifun";

const BawanaInfra = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [totalAmt, setTotalAmt] = useState();
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const { Option } = Select;
  const [form] = Form.useForm();
  const water = Form.useWatch("water", form);
  const cetp = Form.useWatch("cetp", form);
  const maintenance = Form.useWatch("maintenance", form);

  // Update total when any field changes
  useEffect(() => {
    const waterAmount = parseInt(water) || 0;
    const cetpAmount = parseInt(cetp) || 0;
    const maintenanceAmount = parseInt(maintenance) || 0;

    const totalAmount = waterAmount + cetpAmount + maintenanceAmount;
    setTotal(totalAmount);
    form.setFieldsValue({ amount: totalAmount });
  }, [water, cetp, maintenance]);

  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => <p className="font-medium w-[150px]">{text}</p>,
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium">{text}</p>
          </>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <p style={{ width: "100px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Account No",
      dataIndex: "account_no",
      key: "account_no",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Water",
      dataIndex: "water",
      key: "water",
      render: (text) => <a>{text} Rs.</a>,
    },
    {
      title: "Cetp",
      dataIndex: "cetp",
      key: "cetp",
      render: (text) => <a>{text} Rs. </a>,
    },
    {
      title: "Maintenance",
      dataIndex: "maintenance",
      key: "maintenance",
      render: (text) => <a>{text} Rs.</a>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return (
          <>
            {text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : text === "2" ? (
              <Tag color="red">Failed</Tag>
            ) : (
              <Tag color="yellow">Pending</Tag>
            )}
          </>
        );
      },
    },

    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[200px] overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleFinish = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("ac", val.ac);
    formdata.append("password", val.password);
    formdata.append("water", val.water);
    formdata.append("cetp", val.cetp);
    formdata.append("maintenance", val.maintenance);
    formdata.append("amount", total);
    submitBawanaInfra(formdata)
      .then((res) => {
        if (res.status) {
          form.resetFields();
          dispatchtoast(res.message);
          getReport();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn,
    from_date = fromDate,
    to_date = toDate
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getBawanaInfraReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalAmt(res.total_amount);

        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          })
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getReport();
  }, [current, pageSize]);

  useEffect(() => {
    dispatch(setselectedTab("201"));
  }, []);
  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-start items-center">
            <p className="font-bold text-[15px] mb-2">Bawana Infra</p>
          </div>
          <Form
            form={form}
            layout="vertical"
            className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6"
            onFinish={handleFinish}
          >
            <Form.Item
              label="Account No."
              name="ac"
              rules={[{ required: true, message: "Please enter Account No." }]}
            >
              <CommonInput placeholder="Enter Account number" name="ac" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please select an Password" }]}
            >
              <CommonInput placeholder="Enter Password " name="password" />
            </Form.Item>
            <Form.Item
              label="Water Amount"
              name="water"
              rules={[{ required: true, message: "Please enter Water amount" }]}
            >
              <CommonInput
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                placeholder="Enter Amount"
              />
            </Form.Item>

            <Form.Item
              label="CETP"
              name="cetp"
              rules={[{ required: true, message: "Please enter CETP" }]}
            >
              <CommonInput
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                placeholder="Enter CETP"
              />
            </Form.Item>

            <Form.Item
              label="Maintenance"
              name="maintenance"
              rules={[{ required: true, message: "Please enter Maintenance" }]}
            >
              <CommonInput
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                placeholder="Enter maintenance"
              />
            </Form.Item>

            <Form.Item
              label="Total Amount"
              name="amount"
              rules={[{ required: true, message: "Please enter amount" }]}
            >
              <CommonInput disabled value={total} placeholder="Total Amount" />
            </Form.Item>
            <div className="md:col-span-3 flex justify-end mt-2">
              <Button
                type="primary"
                htmlType="submit"
                className="bg-primary hover:bg-primaryhover"
              >
                Create Bawana Infra
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    setResult({
                      data: {
                        Date: record.Date,
                        Name: record.name,
                        Amount: record.amount,
                        DOB: record.dob,
                        Pan: record.pan_number,
                        Status:
                          record.status === "0"
                            ? "Pending"
                            : record.status === "1"
                            ? "Success"
                            : "Failed",
                        Remark: record.remark,
                      },
                      transaction_id: record.transaction_id,
                    });
                    setOpenReceiptDrawer(true);
                  },
                  className: "cursor-pointer text-[12px]",
                };
              }}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {/* {openReceiptDrawer && (
        <ReportDrawer
          title={"Eko Pan Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
            data={result}
        />
      )} */}
    </>
  );
};

export default BawanaInfra;
